module.exports = __webpack_public_path__ + "static/media/setting-tokenDisabled.f4cfb86f.svg";